import { inject } from 'inversify-props';
import { IStorage } from '../../services';
import { PersonSearchRequest } from './PersonSearchRequest';
import { Artist } from './Artist';
import { Company } from './Company';
import { Gender } from '../common/Gender';
import { Stance } from './Stance';

export class ProSearchRequest extends PersonSearchRequest {

	@inject('IStorage')
	public storage: IStorage;

	public stanceIds: number[] = [];
	public stances: Stance[] = [];
	public artistIds: string[] = [];
	public artists: Artist[] = [];
	public companyIds: string[] = [];
	public companies: Company[] = [];
	public genderIds: number[] = [];
	public genders: Gender[] = [];

	constructor(init?: any) {
		super(init);
		if (!init) { return; }
		if (init.artistIds) {
			this.artistIds = Array.isArray(init.artistIds)
				? init.artistIds
				: init.artistIds.split(',');
		}
		if (init.companyIds) {
			this.companyIds = Array.isArray(init.companyIds)
				? init.companyIds
				: init.companyIds.split(',');
		}
		if (init.genderIds) {
			if (Array.isArray(init.genderIds)) {
				this.genderIds = init.genderIds;
			} else {
				const genders = init.genderIds.split(',');
				this.genderIds = genders.map((x) => parseInt(x, null));
			}
		}
		if (init.stanceIds) {
			if (Array.isArray(init.stanceIds)) {
				this.stanceIds = init.stanceIds;
			} else {
				const stances = init.stanceIds.split(',');
				this.stanceIds = stances.map((x) => parseInt(x, null));
			}
		}

		// INSTEAD OF GETTING THESE VALUES FROM THE DATABASE, TRY AND GET THEM FROM LOCAL STORAGE
		const json = this.storage.retrieve('pro-filter');
		if (!json) { return; }

		const prevFilter = JSON.parse(json) as ProSearchRequest;
		if (!prevFilter) { return; }

		if (prevFilter?.artists?.length) {
			for (const id of this.artistIds) {
				const found = prevFilter.artists.find((x) => x.id === id);
				if (found) { this.artists.push(found); }
			}
		}

		if (prevFilter?.stances?.length) {
			for (const id of this.stanceIds) {
				const found = prevFilter.stances.find((x) => x.id === id);
				if (found) { this.stances.push(found); }
			}
		}

		if (prevFilter?.companies?.length) {
			for (const id of this.companyIds) {
				const found = prevFilter.companies.find((x) => x.id === id);
				if (found) { this.companies.push(found); }
			}
		}

		if (prevFilter?.genders?.length) {
			for (const id of this.genderIds) {
				const found = prevFilter.genders.find((x) => x.id === id);
				if (found) { this.genders.push(found); }
			}
		}

	}

	public collapse(): any {
		const response = super.collapse();
		if (this.artistIds?.length) { response.artistIds = this.artistIds.join(','); }
		if (this.companyIds?.length) { response.companyIds = this.companyIds.join(','); }
		if (this.genderIds?.length) { response.genderIds = this.genderIds.join(','); }
		if (this.stanceIds?.length) { response.stanceIds = this.stanceIds.join(','); }
		return response;
	}

	public clear() {
		super.clear();
		this.companyIds = [];
		this.genderIds = [];
		this.artistIds = [];
		this.stanceIds = [];
	}

}
